import React from 'react'
import { useTheme } from '@mui/material'

interface IIconProps {
  width?: string
}

const OldestGamerIcon: React.FC<IIconProps> = (props) => {
  const theme = useTheme()
  return (
    <svg
      id='Layer_1' enableBackground='new 0 0 511.35 511.35' fill={theme.palette.text.primary} height={props.width}
      viewBox='0 0 511.35 511.35' width={props.width} xmlns='http://www.w3.org/2000/svg'
    >
      <g>
        <path
          d='m324.06 265.482c-.005.247-.019.493-.019.741v234.482c0 5.498 4.457 9.956 9.956 9.956s9.956-4.457 9.956-9.956v-230.955c-6.727.578-13.655-.79-19.893-4.268z'
        />
        <path
          d='m375.808 236.375c-.256 6.816-2.5 13.63-6.938 19.558 2.63 2.64 4.259 6.278 4.259 10.29v31.494c0 5.498 4.457 9.956 9.956 9.956s9.956-4.457 9.956-9.956v-31.494c0-12.734-6.941-23.871-17.233-29.848z'
        />
        <path
          d='m289.33 91.006c24.326 8.455 51.05-4.346 59.563-28.839 8.484-24.411-4.427-51.078-28.839-59.563-24.318-8.452-51.047 4.337-59.563 28.839-8.484 24.41 4.427 51.078 28.839 59.563z'
        />
        <g>
          <path
            d='m352.58 217.208-57.545-39.068-9.743-46.813 16.567 34.966 4.663 3.17 8.758-25.271c4.741-13.682 1.835-28.156-6.446-38.789-8.01.568-15.89-.496-23.426-3.114-12.474-4.335-22.884-12.552-29.95-23.461l-2.686-1.213c-14.03-6.338-30.4-4.515-42.692 4.754l-75.843 19.5c-10.885 2.798-17.696 13.604-15.526 24.631l19.932 101.295c1.076 5.469 4.175 10.017 8.357 13.052-.538 1.553-1.31 3.793-3.108 8.992-3.782 10.94-4.233 22.763-1.292 33.959l24.214 92.163-26.66 101.394c-3.805 14.472 4.842 29.288 19.314 33.093 14.44 3.799 29.281-4.814 33.093-19.313l28.471-108.284c1.188-4.516 1.188-9.263 0-13.779l-20.457-77.801 54.938 78.873-32.31 106.217c-4.355 14.316 3.72 29.452 18.036 33.807 14.406 4.384 29.481-3.815 33.806-18.036l36.137-118.798c2.417-7.944 1.057-16.557-3.689-23.371l-42.419-60.9 17.811-51.396-26.456-17.987c-1.781-1.793-14.886-6.83-14.522-21.716l1.862-57.994 11.491 55.215c1.121 5.39 4.295 10.132 8.849 13.224l65.063 44.172c9.86 6.694 23.387 3.976 29.84-6.221 6.167-9.74 3.103-22.679-6.432-29.152zm-181.702-45.261-6.688-33.988 20.273-5.212z'
          />
        </g>
      </g>
    </svg>
  )
}
export default OldestGamerIcon
